exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".Card1 amp-img{width:100%}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/Card1/src/components/contents/Card1/Card1.s.scss"],"names":[],"mappings":"AAEA,eAEI,UAAW,CACZ","file":"Card1.scss","sourcesContent":["@import '~scss/variables';\n\n.Card1 {\n  amp-img {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/contents/Card1/Card1.scss
// module id = 887
// module chunks = 144